import { Stack, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

import { CloseButton } from '@/components/form/baseInputs/Button/CloseButton';
import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';
import { localStorageBooleanSerializer } from '@/utils/localStorageSerializers';

import { DiagramBar } from './DiagramBar';
import { KeyboardShortcutKey, ModifierKey } from './ModifierKey';

/**
 * A dismissable hint bar that instructs users how to multiselect tiles
 * in the presentation diagram editor. Dismissal is persisted via localStorage.
 */
export function DiagramMultiselectHint() {
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.DIAGRAM_MULTISELECT_HINT_DISMISSED,
    false,
    localStorageBooleanSerializer
  );

  const handleDismiss = useCallback(() => {
    setIsDismissed(true);
  }, [setIsDismissed]);

  if (isDismissed) {
    return null;
  }

  return (
    <DiagramBar spacing={1}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="body-xs">
          <ModifierKey />
          +click or <KeyboardShortcutKey>Shift</KeyboardShortcutKey>+drag to
          select multiple tiles to move
        </Typography>
      </Stack>
      <CloseButton size="xs" variant="transparent" onClick={handleDismiss} />
    </DiagramBar>
  );
}
